import React, { useEffect, useState } from "react";
import HeaderMenu from "./header_menu";
import HeaderNavBar from "./header_nav_bar";
import Scrollbar from "../../Pages/scroll";
import { useSelector } from "react-redux";
import Sidebarnew from "./side_barnew";
import performRequest from "../../api/request";
import { useNavigate } from "react-router";

const allowedRoles = [
  process.env.REACT_APP_ROLE_EMPLOYEE,
  process.env.REACT_APP_ROLE_SALLE_ADMIN,
  process.env.REACT_APP_ROLE_SALLE,
  process.env.REACT_APP_ROLE_ADMIN,
  process.env.REACT_APP_ROLE_PURCHASE,
  process.env.REACT_APP_ROLE_AGRONOMIST,
  process.env.REACT_APP_ROLE_OPS,
  process.env.REACT_APP_ROLE_HR,
  process.env.REACT_APP_ROLE_INSPECTION,
  process.env.REACT_APP_ROLE_MARKETING,
  process.env.REACT_APP_ROLE_IT,
  process.env.REACT_APP_ROLE_SSM,
  process.env.REACT_APP_ROLE_SALES_MANAGER,
  process.env.REACT_APP_ROLE_ACCOUNTS,
  process.env.REACT_APP_ROLE_JR_HR,
  process.env.REACT_APP_ROLE_SALESCOORDINATOR,
  process.env.REACT_APP_ROLE_OFFICE_STAFF,
];

const Header = () => {
  const store = useSelector((store) => store.login?.user);
  const navigate = useNavigate();
  let userId = store.UserId;
  const [isAttempted, setIsAttempted] = useState();

  useEffect(() => {
    const today = new Date().getDate();
    if ([15, 28].includes(today)) {
      performRequest("GET", `/test/check-pending-test/${userId}`)
        .then((res) => {
          if (res.data.hasPendingTest === false) {
            setIsAttempted(true);
          }
        })
        .catch((err) => {
          console.log(err, "eror");
        });
    }
  }, []);
  return (
    <>
      <div className="sticky-top">
        {store?.Role !== process.env.REACT_APP_ROLE_SALLE &&
          store?.Role !== process.env.REACT_APP_ROLE_SALLE_ADMIN && (
            <Scrollbar />
          )}
        <HeaderMenu />
        {/* <HeaderNavBar /> */}
        <Sidebarnew />
        {allowedRoles.includes(store?.Role) && !isAttempted && (
          <div className="col-12 container-xl mt-0 d-print-none">
            <div className="card card-sm border border-top-0 rounded-bottom-1 rounded-top-0">
              <div className="card-body py-2 px-3 d-flex align-items-center gap-2">
                <span className="avatar avatar-xs bg-yellow-lt text-yellow">
                  {/* icon */}
                </span>

                <div className="flex-grow-1 d-flex align-items-center gap-2">
                  <strong className="text-yellow mb-0">Test Pending</strong>
                  <span className="text-muted text-sm">
                    You haven’t attempted the current evaluation yet.
                  </span>
                </div>

                <button
                  className="btn btn-warning btn-sm"
                  onClick={() => navigate(`/internal-test/${userId}`)}
                >
                  Start Test
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Header;
